import { ReleaseEntry } from "./homeworkReleasePlan";

export interface ReleaseWrite extends ReleaseEntry {
    id: string;
}

export interface ReleaseOperation {
    writes: ReleaseWrite[];
    completed: number;
}

export const createReleaseOperation = (entries: ReleaseEntry[], operationId: string): ReleaseOperation => {
    if (!entries.length) throw new Error("배포할 과제와 대상을 선택해주세요.");
    return {
        completed: 0,
        writes: entries.map((entry, index) => ({
            ...entry,
            id: entry.id || `${operationId}_${index}`,
            data: { ...entry.data, distribution_id: operationId },
        })),
    };
};

/** Each batch is atomic. Retry the same IDs if a commit acknowledgement is lost. */
export const commitReleaseOperation = async (
    operation: ReleaseOperation,
    commit: (writes: ReleaseWrite[]) => Promise<void>,
    batchSize = 400,
    onProgress?: () => void,
): Promise<void> => {
    if (!Number.isInteger(batchSize) || batchSize < 1 || batchSize > 400) throw new Error("Invalid release batch size");
    while (operation.completed < operation.writes.length) {
        const batch = operation.writes.slice(operation.completed, operation.completed + batchSize);
        await commit(batch);
        operation.completed += batch.length;
        onProgress?.();
    }
};
